//Ejecución de funciones
document.addEventListener('DOMContentLoaded', function() {
    contador();
});

//Animnación con el scroll//
function contador() {
    const contador = document.querySelector('.contador');

    //Registrar el Intersection Observer
    const observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {

            // Animación del contador//
            $('.contador li:nth-child(1) p').animateNumber({ number: 3210 }, 2000);
            $('.contador li:nth-child(2) p').animateNumber({ number: 10 }, 2000);
            $('.contador li:nth-child(3) p').animateNumber({ number: 100 }, 2000);
        }
    })

    //Elemento a obesrvar   
    observer.observe(document.querySelector('.contador'));
}